/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPinIcon20Solid = forwardRef('AttachPinIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.041 1.793c-.661-.661-1.792-.193-1.792.742v.271a3.25 3.25 0 0 1-.952 2.298l-.377.377a3.25 3.25 0 0 1-2.298.953H4.66c-1.247 0-1.872 1.508-.99 2.39l2.869 2.868-4.174 4.174a1.25 1.25 0 1 0 1.768 1.768l4.174-4.174 2.866 2.867c.882.882 2.39.257 2.39-.99v-2.961c0-.862.343-1.689.952-2.298l.377-.377a3.25 3.25 0 0 1 2.299-.953h.27c.935 0 1.404-1.13.742-1.792l-5.163-5.163Z" })));
});
